export default __webpack_public_path__ + "static/media/nopucid_genio.69ee345d.jpg";